import React from 'react';

const NotesSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      {...props}
    >
      <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"/>
      <path fillRule="evenodd" d="M4 5a2 2 0 012-2v1a1 1 0 002 0V3a2 2 0 012 0v1a1 1 0 002 0V3a2 2 0 012 2v6.586A2 2 0 0115.586 13L7 21.414a2 2 0 01-2.828 0L2.586 20a2 2 0 010-2.828L11 8.586V5a2 2 0 00-2-2H4zm7 7l3 3-3 3-3-3 3-3z" clipRule="evenodd"/>
    </svg>
  );
};

export { NotesSVG };
